import { useInstantSearch } from 'react-instantsearch';
const NoResultsBoundary = props => {
  const {
    results
  } = useInstantSearch();
  const {
    fallback,
    children
  } = props;

  // The `__isArtificial` flag makes sure not to display the fallback message
  // when no hits have been returned. This is to prevent the fallback message
  // from showing on initial load. Only when the user actively searches and
  // no results have been found.
  //
  // nbHits returns the number of hits that the search query matched.
  //
  // See for reference:
  // https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-display/react/
  //
  // eslint-disable-next-line no-underscore-dangle
  if (!results.__isArtificial && results.nbHits === 0) {
    return fallback;
  }
  return children;
};
export default NoResultsBoundary;